// @ts-ignore
import { PROBLEM_INNER_TYPES } from '@yandex-int/k-common/constants';

import { ProblemWeb } from './types';

export function isWebProblem(problem: { type: string } | null | undefined): problem is ProblemWeb {
    return problem?.type === PROBLEM_INNER_TYPES.WEB;
}
